export enum UserPlanType {
  USERPLAN_UNSET_TYPE = 'USERPLAN_UNSET_TYPE',
  USERPLAN_SALE = 'USERPLAN_SALE',
  USERPLAN_GIFT = 'USERPLAN_GIFT',
  USERPLAN_REDEMPTION = 'USERPLAN_REDEMPTION',
}
